export default __webpack_public_path__ + "static/media/3-BMSilo.37da9e69.png";